import { render, staticRenderFns } from "./sort-list.vue?vue&type=template&id=2c7adb06&scoped=true&"
import script from "./sort-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./sort-list.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7adb06",
  null
  
)

export default component.exports